import { render } from "./TermsOfUse.vue?vue&type=template&id=15e1114d"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"
script.render = render

export default script